import { isCreateableField } from '@shared/data/entity';
import { EditableFieldRecord } from '@shared/scenes/entity/types';
import { API } from '@shared/types/api';

export function toFieldJson(
  fields: EditableFieldRecord,
  workflowTemplate?: API.WorkflowTemplateFragment,
): { [key: string]: any } {
  return Object.entries(fields).reduce((memo, [componentId, field]) => {
    if (!isCreateableField(componentId, workflowTemplate)) {
      return memo;
    }
    return {
      ...memo,
      [componentId]: field?.toFieldJson() ?? null,
    };
  }, {});
}
